import React from 'react';
import { Shield } from 'lucide-react';
import SEO from '../components/SEO';
import TeamCard from '../components/TeamCard';
import CTASection from '../components/CTASection';
import { teamData } from '../data/teamData';

export default function Team({ onOpenConsultation }) {
  return (
    <div className="bg-canvas">
      <SEO
        title="Our Clinical Team | Psychiatrists, Psychologists & Therapists"
        description="Meet the multidisciplinary medical team at UMED: Senior consultant psychiatrists, clinical psychologists, psychiatric social workers, and rehabilitation therapists."
      />

      {/* Hero */}
      <section className="relative pt-16 pb-20 lg:pt-24 lg:pb-28 bg-[#123B5D] text-white overflow-hidden">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-[#0F766E]/30 via-[#123B5D] to-[#123B5D] pointer-events-none"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 mb-4 px-3 py-1 rounded-full bg-[#0F766E] border border-[#2A9D8F]/30">
              <Shield className="w-3.5 h-3.5 text-[#2A9D8F]" />
              <span className="text-xs uppercase tracking-widest text-white font-semibold">
                Multidisciplinary Clinical Leadership
              </span>
            </div>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white font-normal leading-tight">
              Experienced Minds Dedicated to <span className="text-[#2A9D8F]">Your Healing</span>.
            </h1>
            <p className="mt-6 text-base sm:text-lg text-[#D9E8E5] leading-relaxed">
              At UMED, care is never delivered in isolation. Our senior consultant psychiatrists, licensed clinical psychologists, and rehabilitation therapists collaborate daily to ensure precision medicine and empathetic support.
            </p>
          </div>
        </div>
      </section>

      {/* Team Grid */}
      <section className="py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {teamData.map((member) => (
              <TeamCard key={member.id} member={member} />
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <CTASection onOpenConsultation={onOpenConsultation} />
    </div>
  );
}
